import {Component} from "react";

import * as React from "react";
import {StationLayer} from "./station-layer/station-layer";

import {Kiwis} from "../../../../kiwis";
import {AppState} from "../../app-mobx";
import {MapState} from "../../../../core/map-state";

import {StationLayerConfiguration} from "../../../../config/station-layer-configuration";
import {FeatureLayerConfiguration} from "../../../../core/config/layer-configuration";
import {UiState} from "../../../../core/ui-state";
import EsriFeatureLayer from "@arcgis/core/layers/FeatureLayer";
import FeatureLayerProperties = __esri.FeatureLayerProperties;
import WatchHandle = __esri.WatchHandle;
import _ from "lodash";

export interface StationLayerStackProps {
    kiwis: Kiwis;
    mapStore: MapState;
    appStore: AppState;
    uiStore: UiState;
    config: FeatureLayerConfiguration[];
}

/*
Stack of station layers in a map
 */
export class LayerStack extends Component<StationLayerStackProps, any> {
    autorunDisposers: any[] = [];
    watchHandles: WatchHandle[] = [];

    constructor(props: StationLayerStackProps) {
        super(props);
    }

    render() {
        if (this.props.config == null) {
            return "";
        }
        return this.props.config.map((layerConfig) => {
            if (layerConfig.layerType === "station") {
                return <StationLayer key={layerConfig.id}
                    store={this.props.kiwis}
                    mapStore={this.props.mapStore}
                    appStore={this.props.appStore}
                    uiStore={this.props.uiStore}
                    config={layerConfig as StationLayerConfiguration} />;
            }
        });
    }
    handleLayerChange(config?: FeatureLayerConfiguration[]): void {
        if (!config) {
            return;
        }
        const {mapStore} = this.props;
        config.forEach((layerConfig) => {
            if (mapStore.map && layerConfig.layerType === "feature") {
                mapStore.map.add(new EsriFeatureLayer(layerConfig as FeatureLayerProperties), 0);
            }
        });
    }
    componentDidMount(): void {
        this.handleLayerChange(this.props.config);
    }
    componentWillUnmount() {
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    componentDidUpdate(prevProps: any) {
        const {config} = this.props;
        if (!_.isEqual(prevProps.config, config)){
            this.handleLayerChange(config);
        }
    }
}
